import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Chip, Spinner } from 'react-mdl'
import { withRouter } from 'react-router'

import Body from '../Body'
import app from '../feathers'

import AuthenticatedImage from '../components/AuthenticatedImage'
import Button from '../components/Button'
import ConfirmDelete from '../components/ConfirmDelete'

const Container = styled.div`width: 100%;`

const Content = styled.div`
  width: 100%;
  max-height: 60vh;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`
const ImageContent = styled.div`width: 70%;`
const ImageDetails = styled.div`
  width: 30%;
  border: 1px solid black;
  padding: 10px;
`
const TaggingContent = styled.div`
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
`
const Textarea = styled.textarea`
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
`

const Label = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`

const Tags = styled.div`padding-bottom: 15px;`

const Input = styled.input`
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  padding: 1em;
`

const imagesService = app.service('images')
class ImageEditScreen extends React.Component {
  state = {
    loading: true,
    image: null,
    title: null,
    tags: null,
    newTag: '',
  }
  static contextTypes = {
    prompt: PropTypes.func,
  }
  componentDidMount() {
    this.setInitialState()
  }
  async setInitialState() {
    const id = this.props.match.params.mediaId
    const image = await imagesService.get(id, {
      query: {
        dataOnly: true,
      },
    })
    this.setState({
      image,
      title: image.description,
      tags: image.tags,
      loading: false,
    })
  }

  handleChange = ({ target }) => {
    this.setState({ [target.name]: target.value })
  }

  handleTagSubmit = e => {
    if (e.charCode === 13) {
      this.setState(({ tags, newTag }) => ({
        tags: [...tags, newTag],
        newTag: '',
      }))
    }
  }

  handleDeleteTag = i => {
    this.setState(({ tags }) => ({
      tags: [...tags.slice(0, i), ...tags.slice(i + 1)],
    }))
  }

  handleDelete = async () => {
    const response = await this.context.prompt({
      title: 'Delete Image',
      ContentComponent: ConfirmDelete,
    })
    if (response === 'Delete') {
      await imagesService.remove(this.props.match.params.mediaId)
      this.props.history.goBack()
    }
  }

  handleUpdate = async () => {
    const { title: description, tags } = this.state
    await imagesService.patch(this.props.match.params.mediaId, {
      description,
      tags,
    })
    await this.setInitialState()
    this.props.history.goBack()
  }

  render() {
    const { match: { params: { mediaId } } } = this.props
    const { image, title, tags, newTag, loading } = this.state
    return (
      <Body>
        <Container>
          <h3>Edit Image</h3>
          <p>Set crop on image before rotating or flipping</p>
          <div>
            <Button disabled>Rotate</Button>
            <Button disabled>Flip</Button>
          </div>
          <Content>
            <ImageContent>
              <AuthenticatedImage
                source={`/images/${mediaId}`}
                height="100%"
                style={{
                  objectFit: 'contain',
                  maxWidth: '95%',
                }}
              />
            </ImageContent>
            <ImageDetails>
              <h5>Image Details</h5>
              {loading ? (
                <Spinner />
              ) : (
                <TaggingContent>
                  <Label>Title:</Label>
                  <Textarea
                    rows="4"
                    name="title"
                    value={title}
                    onChange={this.handleChange}
                  />
                  <Label>Tags:</Label>
                  <Tags>
                    {image ? (
                      tags.map((tags, i) => (
                        <Chip key={i} onClose={() => this.handleDeleteTag(i)}>
                          {tags}
                        </Chip>
                      ))
                    ) : (
                      <p>Tags Loading... </p>
                    )}
                  </Tags>
                  <Input
                    type="text"
                    placeholder="Add new tags here..."
                    name="newTag"
                    value={newTag}
                    onChange={this.handleChange}
                    onKeyPress={this.handleTagSubmit}
                  />
                </TaggingContent>
              )}
            </ImageDetails>
          </Content>
          <Content>
            <Button raised accent onClick={this.handleDelete}>
              Delete Permanently
            </Button>
            <Button raised primary onClick={this.handleUpdate}>
              Update
            </Button>
          </Content>
        </Container>
      </Body>
    )
  }
}

export default withRouter(ImageEditScreen)



// WEBPACK FOOTER //
// ./src/AssetLibrary/ImageEditScreen.js